import { queryKeys } from "@/lib/useQuery/queryKeys"
import { useQuery } from "@tanstack/react-query"
import { useGetExportDataProps } from "."

export function useGetExportData(props: useGetExportDataProps) {
    return useQuery({
        ...queryKeys.project.export(props),
        enabled: !!props.projectId && !!props.surveyId
    });
}